export default function EmptyState({ children }) {
  return <div className="empty-state">{children}</div>;
}
